// removed by extract-text-webpack-plugin
module.exports = {"receipt-info-box":"app-components-receipt-previews-InfoBox-__InfoBox___2BCc2","receipt-date":"app-components-receipt-previews-InfoBox-__InfoBox___1fb6K","receipt-number":"app-components-receipt-previews-InfoBox-__InfoBox___kGBdK","receipt-served":"app-components-receipt-previews-InfoBox-__InfoBox___2HgSu","receipt-collected":"app-components-receipt-previews-InfoBox-__InfoBox___3Utaf"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/previews/InfoBox/InfoBox.css
// module id = 2007
// module chunks = 0